<template>
  <svg aria-hidden="true">
    <use :xlink:href="symbolId" :fill="color" />
  </svg>
</template>

<script>
export default {
  name: "SvgIcon",
  props: {
    prefix: {
      type: String,
      default: "icon",
    },
    iconClass: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: "#333",
    },
  },
  computed: {
    symbolId() {
      return `#${this.prefix}-${this.iconClass}`;
    },
  },
};
</script>
